import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';
import "../Checkout/checkout.css";


const ImageUploader = ({ onUploadComplete }) => {
  const [preview, setPreview] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [previews, setPreviews] = useState([]);

/*   const onDrop = useCallback((acceptedFiles) => {
    const file = acceptedFiles[0];
    setPreview(URL.createObjectURL(file)); // Crear una URL de objeto local para previsualización

    const formData = new FormData();
    formData.append('files', file);

    setUploading(true);
    axios.post('https://pedir-imperfctt.p89nps.easypanel.host/uploads', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(response => {
      const imageUrl = `https://pedir-imperfctt.p89nps.easypanel.host/uploads/${response.data.files[0]}`;
      onUploadComplete(imageUrl); // Llama a la función onUploadComplete con la URL de la imagen
    })
    .catch(error => {
      console.error('Error uploading files:', error);
    })
    .finally(() => {
      setUploading(false);
    });
  }, [onUploadComplete]); */


  const onDrop = useCallback((acceptedFiles) => {
    const filesToUpload = acceptedFiles.slice(0, 4 - previews.length); // permite máximo 4
  
    const newPreviews = filesToUpload.map(file => ({
      file,
      url: URL.createObjectURL(file)
    }));
  
    setPreviews(prev => [...prev, ...newPreviews]);
  
    filesToUpload.forEach(file => {
      const formData = new FormData();
      formData.append('files', file);
  
      setUploading(true);
      axios.post('https://pedir-imperfctt.p89nps.easypanel.host/uploads', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(response => {
        const imageUrl = `https://pedir-imperfctt.p89nps.easypanel.host/uploads/${response.data.files[0]}`;
        onUploadComplete(imageUrl); // 📤 Llamada con cada URL
      })
      .catch(error => {
        console.error('Error uploading files:', error);
      })
      .finally(() => {
        setUploading(false);
      });
    });
  }, [onUploadComplete, previews]);
  


/*   const { getRootProps, getInputProps } = useDropzone({ onDrop }); */


const { getRootProps, getInputProps } = useDropzone({ 
  onDrop, 
  multiple: true, 
  accept: 'image/*'
});


  return (
    <div>
        <label>Subir imagen del combo:</label>
        <br></br>
      <div {...getRootProps({ className: 'dropzone' })}>
        <input {...getInputProps()} />
        <p>Arrastra y suelta algunas imágenes aquí, o haz clic para seleccionar archivos</p>
      </div>
      {preview && (
        <div className="preview" style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
  {previews.map((img, i) => (
    <img key={i} src={img.url} alt={`preview-${i}`} style={{ width: '100px', height: '100px', objectFit: 'cover' }} />
  ))}
</div>

      )}
      {uploading && <p>Subiendo imagen...</p>}
    </div>
  );
};

export default ImageUploader;
